// extracted by mini-css-extract-plugin
export var cartContainer = "_gn-4";
export var gray = "_gn-1";
export var itemContainer = "_gn-2";
export var itemDetails = "_gn-3";
export var strong = "_gn-0";